import React, { useState } from 'react';

// Components
import Item from './Item';
import getCookie from '../Queries/getCookie';
import LanguageSelect from '../LanguageSelect';
import MyAccountMobile from '../MyAccountMobile';

// Styles
import styles from './index.module.sass';

//Objects
import taxonomy from '../Queries/menuObject';

export default function MenuHeaderMobile(props) {
  const {
    open,
    setOpen,
    history = {},
    showMenu,
    setshowMenu,
    setshow,
    show,
    itemSelectedAccount,
    setItemSelectedAccount,
  } = props;
  const [itemSelected, setItemSelected] = useState(null);

  const cont = process.env.REACT_APP_COUNTRY;

  function menu() {
    setOpen(false);
    setshowMenu(false);
    setshow(false);
    setItemSelectedAccount(false);
  }

  return (
    <>
      {open && <div className={styles.overlay} onClick={() => menu()} />}
      <div id={styles.departaments} className={`${styles.phone} ${styles[open]}`}>
        {!showMenu ? (
          <>
            {taxonomy.map((val, key) => {
              if (val.country && val.country === cont)
                return (
                  <Item
                    val={val}
                    history={history}
                    setOpen={setOpen}
                    selected={key}
                    setItemSelected={setItemSelected}
                    itemSelected={itemSelected}
                    key={key}
                  />
                );
              else if (val.country && val.country !== cont) return null;
              else
                return (
                  <Item
                    val={val}
                    history={history}
                    setOpen={setOpen}
                    selected={key}
                    setItemSelected={setItemSelected}
                    itemSelected={itemSelected}
                    key={key}
                  />
                );
            })}
          </>
        ) : (
          <></>
        )}
        <div>
          <MyAccountMobile
            history={history}
            getCookie={getCookie}
            setOpen={setOpen}
            setshowMenu={setshowMenu}
            setshow={setshow}
            show={show}
            itemSelectedAccount={itemSelectedAccount}
            setItemSelectedAccount={setItemSelectedAccount}
          />
        </div>
        <div className={styles.footerMenu}>{getCookie('kitName')}</div>
        <div className={styles.footerKit}>{getCookie('usuario')}</div>
        <div className={styles.languaje}>
          <LanguageSelect />
        </div>
      </div>
    </>
  );
}
